import { render, staticRenderFns } from "./AddHelpRecord.vue?vue&type=template&id=09a1dd03&scoped=true"
import script from "./AddHelpRecord.vue?vue&type=script&lang=js"
export * from "./AddHelpRecord.vue?vue&type=script&lang=js"
import style0 from "./AddHelpRecord.vue?vue&type=style&index=0&id=09a1dd03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a1dd03",
  null
  
)

export default component.exports